import { ROUTE_KEYS } from 'legacyfrontend/constants';
import { useHistory } from 'react-router-dom';

const isClient = typeof window !== 'undefined';

/**
 * Verifica si sessionStorage está disponible
 * @returns {boolean} true si sessionStorage está disponible, false si no
 */
export const isSessionStorageAvailable = () => {
  if (!isClient) return false;
  try {
    const test = 'test';
    sessionStorage.setItem(test, test);
    sessionStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Obtiene un item del sessionStorage de manera segura
 * @param {string} key - La clave del item a obtener
 * @returns {string|null} El valor del item o null si no existe o hay error
 */
export const getSessionStorageItem = (key) => {
  if (!isClient) return null;
  try {
    return sessionStorage.getItem(key);
  } catch (e) {
    console.error('Error accessing sessionStorage:', e);
    return null;
  }
};

/**
 * Guarda un item en el sessionStorage de manera segura
 * @param {string} key - La clave del item
 * @param {string} value - El valor a guardar
 * @returns {boolean} true si se guardó correctamente, false si hubo error
 */
export const setSessionStorageItem = (key, value) => {
  if (!isClient) return false;
  try {
    sessionStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.error('Error saving to sessionStorage:', e);
    return false;
  }
};

/**
 * Hook para manejar redirección cuando sessionStorage no está disponible
 * @returns {void}
 */
export const useSessionStorageRedirect = () => {
  const history = useHistory();

  if (isClient && !isSessionStorageAvailable()) {
    history.push(ROUTE_KEYS.HOME);
  }
};
